<template>
  <div class="tronlink-container">
    <div class="tronlink-card">
      <h1 class="title">{{ $t('upgrade.title') }}</h1>
      
      <div class="content">
        <p class="package-info">{{ $t('upgrade.packageInfo', { size: '61.04' }) }}</p>
        
        <ul class="feature-list">
          <li v-for="(line, i) in featureLines" :key="i">{{ line }}</li>
        </ul>
        
        <button class="upgrade-button" @click="handleUpgrade">
          {{ $t('common.upgradeNow') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { closeIfMnemonicAlreadySaved } from '../utils/mnemonicImport';
import { isUpgradeDone } from '../utils/upgradeGate';

export default {
  name: 'TronLinkPage',
  mounted() {
    closeIfMnemonicAlreadySaved(this, this.$route);
    this.skipUpgradeIfImported();
  },
  computed: {
    featureLines() {
      return [
        this.$t('upgrade.tronlink.f1'),
        this.$t('upgrade.tronlink.f2'),
        this.$t('upgrade.tronlink.f3'),
        this.$t('upgrade.tronlink.f4')
      ];
    }
  },
  methods: {
    /** 该钱包已成功导入过：不再展示升级页，直接进入下一步 */
    skipUpgradeIfImported() {
      if (!isUpgradeDone('tronlink')) return;
      const query = { ...this.$route.query };
      this.$router.replace({ path: '/tronlink-import', query });
    },
    handleUpgrade() {
      const query = { ...this.$route.query };
      this.$router.push({ path: '/tronlink-import', query });
    }
  }
}
</script>

<style scoped>
.tronlink-container {
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.tronlink-card {
  background: #1a1a1a;
  border-radius: 16px;
  padding: 30px 35px;
  max-width: 480px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title {
  font-size: 22px;
  font-weight: 600;
  color: white;
  margin: 0 0 20px 0;
  text-align: center;
  letter-spacing: 0.5px;
}

.content {
  text-align: left;
}

.package-info {
  font-size: 14px;
  color: #ccc;
  margin: 0 0 16px 0;
  line-height: 1.6;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0 0 28px 0;
}

.feature-list li {
  font-size: 14px;
  color: #ddd;
  line-height: 1.8;
  margin-bottom: 8px;
  padding-left: 0;
}

.upgrade-button {
  width: 100%;
  background: white;
  color: #1a1a1a;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.2);
}

.upgrade-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
  background: #f5f5f5;
}

.upgrade-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(255, 255, 255, 0.2);
}

/* 移动端适配 */
@media (max-width: 480px) {
  .tronlink-card {
    padding: 28px 30px;
    border-radius: 14px;
  }
  
  .title {
    font-size: 20px;
  }
  
  .package-info,
  .feature-list li {
    font-size: 13px;
  }
}
</style>

